import type { ReactElement } from 'react';
import * as Icons from './Logos/index.js';

export enum ShippingProvider {
    POSTEN = 'POSTEN', // FINN
    HELTHJEM = 'HELTHJEM', // FINN
    POSTNORD = 'POSTNORD', // FINN
    POSTI = 'POSTI', // Tori
    MATKAHUOLTO = 'MATKAHUOLTO', // Tori
    DAO = 'DAO', // DBA
    GLS = 'GLS', // DBA
    BRING = 'BRING', // DBA
}

const SHIPPING_PROVIDERS: Record<ShippingProvider, { name: string; logo: ReactElement }> = {
    [ShippingProvider.POSTEN]: { name: 'Posten', logo: <Icons.PostenLogo /> },
    [ShippingProvider.HELTHJEM]: { name: 'Helthjem', logo: <Icons.HelthjemLogo /> },
    [ShippingProvider.POSTNORD]: { name: 'PostNord', logo: <Icons.PostnordLogo /> },
    [ShippingProvider.POSTI]: { name: 'Posti', logo: <Icons.PostiLogo /> },
    [ShippingProvider.MATKAHUOLTO]: { name: 'Matkahuolto', logo: <Icons.MatkahuoltoLogo /> },
    [ShippingProvider.DAO]: { name: 'DAO', logo: <Icons.DAOLogo /> },
    [ShippingProvider.GLS]: { name: 'GLS', logo: <Icons.GLSLogo /> },
    [ShippingProvider.BRING]: { name: 'Posten Bring', logo: <Icons.BringLogo /> },
};

export type ShippingProduct =
    | 'HELTHJEM_MEGTILDEG' // Finn
    | 'MYPACK_GO' // Finn
    | 'NORGESPAKKE' // Finn
    | 'NORGESPAKKE_ORDINARY' // Finn
    | 'KOTIPAKETTI' // Tori
    | 'POSTIPAKETTI' // Tori
    | 'PIKKUPAKETTI' // Tori
    | 'MATKAHUOLTO_HOME' // Tori
    | 'MATKAHUOLTO_SHOP' // Tori
    | 'GLS_SHOP' // DBA
    | 'GLS_HOME' // DBA
    | 'DAO_SHOP' // DBA
    | 'DAO_HOME' // DBA
    | 'BRING_PACK'; // DBA

export interface PackageSize {
    title: string;
    sizeString: string;
    size: string;
    subText: string;
    callout?: string;
}

export type PackageSizes = {
    title: string;
    text: string;
    xsmall?: PackageSize;
    small?: PackageSize;
    smallPlus?: PackageSize;
    medium?: PackageSize;
    large?: PackageSize;
    xlarge?: PackageSize;
};

export const getShippingProviderLogo = (provider: ShippingProvider) =>
    SHIPPING_PROVIDERS[provider]?.logo ?? null;

export const getShippingProviderName = (provider: ShippingProvider) =>
    SHIPPING_PROVIDERS[provider]?.name;

export { SHIPPING_PROVIDERS };
